// На каких страницах видна кнопка «Поддержка» (OXEM-760).
//
// Правило из постановки: кнопка живёт на ОБЩИХ и СПИСКОВЫХ страницах (лендинг,
// главная, списки материалов и инструментов, настройки, тарифы, каталог) и не
// появляется на детальных — конспект, карточки, тест, эссе, лекция, курс, чат
// репетитора. Там своё рабочее место, свои нижние панели и поля ввода, и
// плавающая кнопка поверх них только мешает.
//
// Решение принимается по `routeId` отрисованного маршрута, а не по адресу:
// детальная страница в file-based роутинге — это маршрут с параметром
// (`/materials/$materialId`, `/tutor/$sessionId`, `/courses/$courseId`), и
// новая детальная страница скрывает кнопку сама, без правки этого файла.
// Языковой префикс публичных страниц (`/de/about`) в `routeId` не попадает.

/**
 * Маршруты с параметром, которые на деле — списки или общие страницы.
 * Папка библиотеки — список материалов, юридический документ — общий текст.
 */
const PARAM_ROUTES_ALLOWED: ReadonlySet<string> = new Set([
	"/library/folders/$folderId",
	"/legal/$kind",
]);

/**
 * Маршруты без параметра, где кнопки нет.
 *
 * Шлюзы (вход, онбординг, согласие, вход под чужим аккаунтом, оплата) —
 * полноэкранные потоки, отвлекать посреди них нельзя. Мастера создания
 * (`…/new`) — та же рабочая область, что и детальная страница, с собственной
 * нижней панелью действий.
 */
const HIDDEN_PREFIXES: readonly string[] = [
	"/auth",
	"/onboarding",
	"/legal/accept",
	"/impersonate",
	"/shared",
	"/billing",
	"/offline",
	"/recordings/new",
	"/audio-recaps/new",
	"/voice-tutor/new",
	"/courses/new",
];

function matchesPrefix(routeId: string, prefix: string): boolean {
	return routeId === prefix || routeId.startsWith(`${prefix}/`);
}

/** Показывать ли кнопку «Поддержка» на маршруте с этим `routeId`. */
export function isSupportWidgetRoute(routeId: string): boolean {
	const normalized = routeId.length > 1 && routeId.endsWith("/") ? routeId.slice(0, -1) : routeId;
	if (HIDDEN_PREFIXES.some((prefix) => matchesPrefix(normalized, prefix))) return false;
	if (normalized.includes("$")) return PARAM_ROUTES_ALLOWED.has(normalized);
	return true;
}
